import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setSubscriberPersonalData, setCollaborationApproval, getOwnershipTransferSignatureFile } from '../OwnershipTransferCustomerSlice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import TextInput from '../../../Shared/TextInput/TextInput';
import { OwnershipTransferCustomerStep } from '../Constant/Constant';
import { validateInput, TextInputEnum } from '../../../../utilities/validation/InputValidation';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const CustomerForm = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.DetailPage,
        messageText: DWHMessageText.DetailPageDisplayed,
        status: DWHStatus.Ongoing
      });
    }
  }, []);

  const [errors, setErrors] = useState({ firstName: '', lastName: '', email: '' });
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [checkbox, setCheckbox] = useState([
    {
      id: 0,
      title: (
        <div className='checkboxes-title'>
          קראתי ואני מסכימ/ה ל
          <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(props.data.selectedPricePlan.programDetailsLink)}>
            עיקרי פרטי התכנית
          </a>
          ,ל
          <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(props.data.selectedPricePlan.connectionAgreementLink)}>
            הסכם ההתקשרות
          </a>
          ו
          <a href='#' className='link' onClick={() => Config.cooperationTermsLink ? buildUrlAndOpenWindow(Config.cooperationTermsLink) : null}>
            לתנאים הכלליים*
          </a>
        </div >
      ),
      checked: false,
    },
    {
      id: 1,
      title: (
        <div className='checkboxes-title'>
          <ThirdParty />
        </div>
      ),
      checked: false,
    },
  ]);

  function nextStep() {
    if (!validateRequiredData()) {
      setShowErrorMsg(true);
    } else {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.DetailPage,
        messageText: DWHMessageText.DetailPageButtonClicked,
        status: DWHStatus.Ongoing
      });
      setShowErrorMsg(false);
      const validateFileStatus = {
        PhoneNumber: props.userDetails.contactNumber,
        Email: props.data.subscriberPersonalData.email,
        RequestId: props.data.requestId,
        RequestType: 0
      }
      if (props.data.signatureFile.isSigned) { props.setCurrentStep(OwnershipTransferCustomerStep.AddressForm); }
      else {
        props.getOwnershipTransferSignatureFile(validateFileStatus);
      }
    }
  }

  function onCheck(index) {
    let temp = [...checkbox];
    temp[index].checked = !temp[index].checked;
    setCheckbox(temp);
    setShowErrorMsg(false);
    if (index == 1) {
      props.setCollaborationApproval(temp[index].checked);
    }
  }
  function validateRequiredData() {
    if (
      Object.values(errors).some((value) => value !== '') ||
      Object.values(props.data.subscriberPersonalData).some((value) => value.trim() === '')
    ) {
      setErrorText('כדי להמשיך יש למלא את כל שדות החובה ');
      return false;
    } else if (checkbox.filter((ch) => ch.checked).length == 0 || !checkbox.find((ch) => ch.id == 0).checked) {
      setErrorText('כדי להמשיך יש לאשר את עיקרי התכנית');
    } else {
      setErrorText('');
      return true;
    }
  }

  return (
    <div className='ownership-transfer-form'>
      <div className='l-title center'>נעשה היכרות קצרה ונמשיך</div>
      <div className='stepContainer'>
        <div>
          <TextInput
            value={props.data.subscriberPersonalData.firstName}
            error={errors.firstName}
            id='firstName'
            placeholder={'שם פרטי'}
            onChange={(e) => {
              setErrors({ ...errors, firstName: validateInput(e.target.value, TextInputEnum.FirstName) });
              props.setSubscriberPersonalData({ firstName: e.target.value });
              setShowErrorMsg(false);
            }}
            required='required'
          />
          <TextInput
            value={props.data.subscriberPersonalData.lastName}
            error={errors.lastName}
            id='lastName'
            placeholder={'שם משפחה'}
            onChange={(e) => {
              setErrors({ ...errors, lastName: validateInput(e.target.value, TextInputEnum.LastName) });
              props.setSubscriberPersonalData({ lastName: e.target.value });
              setShowErrorMsg(false);
            }}
            required='required'
          />
        </div>
        <div className='customer-email'>
          <div className='customer-email-title semi'>כתובת מייל ראשית לדיוור ומידע</div>
          <TextInput
            value={props.data.subscriberPersonalData.email}
            error={errors.email}
            id='mail'
            placeholder={'מייל'}
            onChange={(e) => {
              setErrors({ ...errors, email: validateInput(e.target.value, TextInputEnum.Mail) });
              props.setSubscriberPersonalData({ email: e.target.value });
              setShowErrorMsg(false);
            }}
            required='required'
          />
          <div className='customer-email-text text-under-input'>
            {Config.primaryEmailText}{' '}
            <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl)} target='_blank'>
              {Config.primaryEmailMoreInfoText}
            </a>{' '}
          </div>
        </div>
        <div className='checkboxes'>
          {checkbox.map((item, index) => {
            return (
              <div className='transfer-checkbox' key={index}>
                <CheckBox
                  id={index}
                  onCheck={() => onCheck(index)}
                  onUncheck={() => onCheck(index)}
                  checked={item.checked}
                  label={item.title}
                />
              </div>
            );
          })}
        </div>

        <div className='continue-button'>
          {showErrorMsg && <div className='error center'>{errorText}</div>}
          <BtnSubmit onclick={nextStep} text={'אפשר להמשיך'} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSubscriberPersonalData,
  setCollaborationApproval,
  getOwnershipTransferSignatureFile
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerForm);
